/* eslint-disable no-unused-vars */
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Search, ClearSearchInput } from 'assets/icons';
import * as S from './ChooseBase.styled';

const OneSection = ({
  searchValue,
  searchOnChange,
  children,
  showBtnDeselectAll,
  isGroupOpen,
  handleDeselectAll,
  handleCollapseAll,
  handleClearSearchValue,
  dontShowHeader,
  title = 'Search',
}) => {
  const [searchInputFocus, setSearchInputFocus] = useState(false);

  return (
    <S.Container>
      <S.ChooseBox>
        <S.Header dontShowHeader={dontShowHeader}>
          <S.LinkAction onClick={handleDeselectAll} visible={true} disabled={!showBtnDeselectAll}>
            Deselect All
          </S.LinkAction>
          <S.LinkAction onClick={handleCollapseAll} visible={true} disabled={!isGroupOpen}>
            Collapse All
          </S.LinkAction>
        </S.Header>
        <div>
          <S.SearchInputWrapper>
            <S.SearchInput
              onFocus={() => setSearchInputFocus(true)}
              onBlur={() => setSearchInputFocus(false)}
              placeholder={title}
              value={searchValue}
              onChange={searchOnChange}
              oneSection
            />
            <S.SearchIconWrapper isFocusable={searchInputFocus}>
              <Search />
            </S.SearchIconWrapper>
            <S.ClearSearchInputWrapper visible={!!searchValue} onClick={handleClearSearchValue}>
              <ClearSearchInput />
            </S.ClearSearchInputWrapper>
          </S.SearchInputWrapper>
          <S.ChooseMain>{children}</S.ChooseMain>
        </div>
      </S.ChooseBox>
    </S.Container>
  );
};

const Divided = ({
  searchValue,
  searchOnChange,
  children,
  handleClearSearchValue,
  title = 'Search',
}) => {
  const [searchInputFocus, setSearchInputFocus] = useState(false);

  const inputRef = useRef(null);

  return (
    <S.Container>
      <S.ChooseBox>
        <S.SearchInputWrapper>
          <S.SearchInput
            ref={inputRef}
            onFocus={() => setSearchInputFocus(true)}
            onBlur={() => setSearchInputFocus(false)}
            placeholder={title}
            value={searchValue}
            onChange={searchOnChange}
          />
          <S.SearchIconWrapper isFocusable={searchInputFocus}>
            <Search />
          </S.SearchIconWrapper>
          <S.ClearSearchInputWrapper
            visible={!!searchValue}
            onClick={() => {
              handleClearSearchValue();
              setSearchInputFocus(true);
              inputRef.current.focus();
            }}
          >
            <ClearSearchInput />
          </S.ClearSearchInputWrapper>
        </S.SearchInputWrapper>
        <S.ContainerForScroll>
          <S.ChooseMain>{children}</S.ChooseMain>
        </S.ContainerForScroll>
      </S.ChooseBox>
    </S.Container>
  );
};

const ChooseBase = { OneSection, Divided };

const oneSectionTypes = {
  searchValue: PropTypes.string.isRequired,
  searchOnChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  showBtnDeselectAll: PropTypes.bool,
  isGroupOpen: PropTypes.bool,
  handleDeselectAll: PropTypes.func,
  handleCollapseAll: PropTypes.func,
  handleClearSearchValue: PropTypes.func,
};

OneSection.protoTypes = oneSectionTypes;

export default ChooseBase;
